import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78767a30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  controls: "",
  autoplay: "true",
  class: "animation-duration-200 animation-ease-in-out"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { ref, onMounted, inject } from "vue";
import { get, set } from "@vueuse/core";
import VideoSpinner from "../spinner.vue";
import Dialog from "primevue/dialog";
import { DirectMessageServices } from "@/clinic/services";
import { IDirectMessage } from "@/clinic/typings";

type IVideoDialog = {
  id: number;
  content?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'video',
  props: {
    id: null,
    content: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  id: number;
  content?: string;
};

const visible = ref(false);

const closable = ref(true);

const video = ref("");

const boxVideoSpinner = ref<HTMLElement>();

const show = () => set(visible, true);

const hide = () => set(visible, false);



const clinicId = inject<number>("clinicId");

const onPlay = async () => {
  show();
  get(boxVideoSpinner)?.show();
  const { data } = await DirectMessageServices.getMessage(
    { id: props.id, clinic_id: get(clinicId) as number },
    () => {
      get(boxVideoSpinner)?.hide();
      set(closable, true);
    },
    () => undefined
  );
  const { content } = get(data) as unknown as IDirectMessage;
  set(video, content);
};

onMounted(() => get(boxVideoSpinner)?.hide());

// eslint-disable-next-line no-undef
expose({
  onPlay,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    modal: "",
    draggable: false,
    class: "w-full h-full max-h-full video-dialog border-noround",
    onHide: hide,
    closable: closable.value
  }, {
    default: _withCtx(() => [
      _createVNode(VideoSpinner, {
        ref_key: "boxVideoSpinner",
        ref: boxVideoSpinner,
        hasFull: false,
        loadMore: true,
        className: "top-0 video-spinner"
      }, null, 512),
      (!_unref(get)(boxVideoSpinner.value)?.getVisible())
        ? (_openBlock(), _createElementBlock("video", _hoisted_1, [
            _createElementVNode("source", {
              type: "video/webm",
              src: video.value
            }, null, 8, _hoisted_2),
            _createElementVNode("source", {
              type: "video/mp4",
              src: video.value
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "closable"]))
}
}

})